import _ from 'lodash';

export function createDebouncedFn(fn, options = {}) {
    const { delay = 500 } = options;

    const debouncedFn = _.debounce(async (...args) => {
        await fn(...args);
    }, delay);

    const originalCancel = debouncedFn.cancel.bind(debouncedFn);
    debouncedFn.cancel = () => {
        originalCancel();
    };

    const originalFlush = debouncedFn.flush.bind(debouncedFn);
    debouncedFn.flush = () => {
        originalFlush();
    };

    return debouncedFn;
}
